import React, { Component } from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Spinner, OfflineDialpad } from 'modules/theme';
import { globalStateSelector } from '../../../store/selector';
import { messageAction, globalAction, callAction } from '../../../store/action';
export class Offline extends Component {
  constructor( props ) {
    super(props);
    this.allowMedia = this.allowMedia.bind(this);
    this.getMediaPermission = this.getMediaPermission.bind(this);
    this.buttonLoadingTimer = this.buttonLoadingTimer.bind(this);
    this.resetTimer = this.resetTimer.bind(this);
    this.timeout = "";
    this.buttonTimeout = "";
    this.timer = 0;
    this.state = {
      "loading":false,
      "timerText":""
    }
  }
  sendMessage(message) {
    const { emitSocketMessage } = this.props;
    emitSocketMessage('message-processor', message);
  }
  callProcess(type, message) {
    const { callProcess } = this.props;
    callProcess(type, message);
  }
  async allowMedia() {
    const { dynamicUpdate,registerUser,sipConfig  } = this.props;
    try {
      navigator.mediaDevices.getUserMedia( { audio: true, video: false } )
      .then( ( stream ) => {
              // microphone available
        console.log("Allowed", stream)
        stream.getTracks().forEach(function(track) {
          track.stop();
        });
        dynamicUpdate({ key: 'microPhoneState', value: "registered" });
        this.buttonLoadingTimer();
        registerUser("sip",{sipConfig,forceOnline : true})
      }, e => {
        console.log(" microphone not available", e)
        dynamicUpdate({ key: 'microPhoneState', value: "denied" });
        clearTimeout(global.__btnTimer);
      } );
    } catch (error) {
      console.log("microphone not available error", error);
      dynamicUpdate({ key: 'microPhoneState', value: "error" });
      clearTimeout(global.__btnTimer);
    }
  }
  async getMediaPermission() {
    const { dynamicUpdate, registerUser, sipConfig } = this.props;
    try{
      let microPhone = await navigator.permissions.query({ name: 'microphone' })
      console.log("microPhone",microPhone)
      if( microPhone && microPhone.state ){
        if( microPhone.state  == "denied"){
          dynamicUpdate({ key: 'microPhoneState', value: "denied" });
          clearTimeout(global.__btnTimer);
        } else if( microPhone.state  == "granted"){
          dynamicUpdate({ key: 'microPhoneState', value: "registered" });
          this.buttonLoadingTimer();
          registerUser("sip",{sipConfig,forceOnline : true})
        } else if( microPhone.state  == "prompt"){
          dynamicUpdate({ key: 'microPhoneState', value: "prompt" });
          clearTimeout(global.__btnTimer);
          this.allowMedia();
        }
      } else {
        this.allowMedia();
      }
    } catch (ex){
      console.log("Error in microphone");
      dynamicUpdate({ key: 'microPhoneState', value: "prompt" });
      this.allowMedia();
    }
  }
  buttonLoadingTimer() {
    const { dynamicUpdate, microPhoneState } = this.props
    this.setState({"loading":true});
    try {
      clearTimeout(global.__btnTimer);
      this.timer = 35
      dynamicUpdate({ key: 'timerText', value: "" });
      global.__btnTimer = setInterval(()=>{
        this.timer--;  
        if( this.timer <= 0 ){
          this.setState({"loading":false});
          dynamicUpdate({ key: 'microPhoneState', value: "" });
        } else if( this.timer < 30 ){
          dynamicUpdate({ key: 'timerText', value: `Retry in ${this.timer} seconds` });
        }
        console.log("microPhoneState", microPhoneState, this.timer);
      },1000)
    } catch (error) {
      console.log("Get Permission error",error )
    }
  }
  resetTimer( microPhoneState ) {
    if( microPhoneState != "loading" && microPhoneState != "registered" && microPhoneState != "prompt" ){
      clearTimeout(global.__btnTimer);
      console.log("resetTimer clearTimeout", microPhoneState);
    } else {
      console.log("resetTimer clearTimeout", microPhoneState);
    }
  }
  render() {
    const { socketUrl, currentUser, sipConfig, cbNotify, dynamicUpdate, microPhoneState, timerText, bridgeState = "", bridgeStateOTP = ""  } = this.props;
    let errorMessage = "";
    if( ! socketUrl ) {
      errorMessage = "We didn't Found Socket URL";  
    }
    else if( !currentUser.phoneType ) {
      errorMessage = "Please define your phone type";  
    }
    else if( currentUser.phoneType  ) {

      if( (currentUser.phoneType == "pstn" || currentUser.phoneType == "bridge" ) && !currentUser.mobile_number ){
        errorMessage = "Your Mobile Number not Define.";  
      } else if( currentUser.phoneType == "web" && !sipConfig ){
        errorMessage = "Your Web is not configured.";
      } else if( currentUser.phoneType == "mobileEndPoint" && !sipConfig ){
        errorMessage = "Your SIP is not configured.";
      }
    }
    let loading = ( microPhoneState == "loading" || microPhoneState == "registered" ||  microPhoneState == "prompt" ) ? true : false;
    this.resetTimer(microPhoneState);
    let nextState = cbNotify ? "callback" : "online";
    return (
      <React.Fragment>
        { loading &&  <Spinner />}
        { (microPhoneState == "loading" || microPhoneState == "registered" ) &&
          <React.Fragment>
            {microPhoneState == "loading" && <h5 style={{ "marginTop": "23px","textAlign": "center"}}>Loading...</h5>}
            {microPhoneState == "registered" && <h5 style={{ "marginTop": "23px","textAlign": "center"}}>Registering...</h5>}
            { timerText && <div style={{ "textAlign": "center"}}>{timerText}</div>}
          </React.Fragment>
        }
        {microPhoneState == "denied" && <h5 style={{ "marginTop": "23px","textAlign": "center"}}>Please give permission to access your microphone</h5>}
        {microPhoneState == "prompt" && <h5 style={{ "marginTop": "23px","textAlign": "center"}}>Please allow us to access your microphone</h5>}
        {microPhoneState == "error" && <h5 style={{ "marginTop": "23px","textAlign": "center"}}>ERROR </h5>}
        {bridgeState == "connecting" && <h5 style={{ "marginTop": "23px","textAlign": "center"}}>You are on bridge mode, Please pickup call and enter verification code</h5>}
        {bridgeState == "disconnect" && <h5 style={{ "marginTop": "23px","textAlign": "center"}}>Call Disconnected</h5>}
        {bridgeStateOTP && <h5 style={{ "marginTop": "23px","textAlign": "center"}}>{bridgeStateOTP}</h5>}
        { !loading && ( bridgeState == "" || bridgeState == "disconnect" ) &&
          <OfflineDialpad
            error={errorMessage}
            ButtonText={'Go Online'}
            OnClickEvent={() => {
              this.buttonLoadingTimer();
              if( currentUser.phoneType == "bridge" ) {
                dynamicUpdate({"key":"cbNotify",value : false });
                dynamicUpdate({ key: 'microPhoneState', value: "" });
                dynamicUpdate({ key: 'bridgeState', value: "connecting" });
                dynamicUpdate({ key: 'bridgeStateOTP', value: "- - - -" });
                this.callProcess('bridgeCall', {});
              } else if( currentUser.phoneType == "pstn" || currentUser.phoneType == "mobileEndPoint" ) {
                let message = {
                  type: 'stateHandler',
                  state: nextState,
                  subState: '',
                  stateInfo: ''
                };
                dynamicUpdate({"key":"cbNotify",value : false });
                dynamicUpdate({ key: 'microPhoneState', value: "" });
                this.sendMessage(message)
              } else {
                console.log("Register Web");
                dynamicUpdate({ key: 'microPhoneState', value: "loading" });
                try {
                  clearTimeout(this.timeout);
                  this.timeout = setTimeout(()=>{
                    this.getMediaPermission();
                  },1000)
                } catch (error) {
                  console.log("Get Permission error",error )
                  dynamicUpdate({ key: 'microPhoneState', value: "error" });
                }
              }
            }}
          >
          </OfflineDialpad>
        }
      </React.Fragment>
    )
  }
}


Offline.contextTypes = {
  __: PropTypes.func
};

const stateToProps = state => ({
  isConnected: globalStateSelector.getIsConnected(state),
  userState: globalStateSelector.getState(state),
  currentUser: globalStateSelector.getDynamic(state, { key: 'currentUser' }),
  sipConfig: globalStateSelector.getDynamic(state, { key: 'sipConfig' }),
  socketUrl: globalStateSelector.getDynamic(state, { key: 'socketUrl' }),
  microPhoneState: globalStateSelector.getDynamic(state, { key: 'microPhoneState' }),
  bridgeState: globalStateSelector.getDynamic(state, { key: 'bridgeState' }),
  bridgeStateOTP: globalStateSelector.getDynamic(state, { key: 'bridgeStateOTP' }),
  timerText: globalStateSelector.getDynamic(state, { key: 'timerText' }),
  phoneType: globalStateSelector.getDynamic(state, { key: 'phoneType' }),
  cbNotify: globalStateSelector.getDynamic(state, { key: 'cbNotify' }),
});

const dispatchToProps = dispatch => ({
  clearSocketConnection: () => {
    // dispatch(messageAction.emitSocketMessage());
  },
  dynamicUpdate: data => {
    dispatch(globalAction.dynamicUpdate({ data }));
  },
  registerUser: (type, messageData) => {
    dispatch(messageAction.registerUser(type, messageData));
  },
  emitSocketMessage: (type, messageData) => {
    dispatch(messageAction.emitSocketMessage(type, messageData));
  },
  callProcess: (type, messageData) => {
    dispatch(callAction.process(type, messageData));
  }
});

export default connect(stateToProps, dispatchToProps)(Offline)


// WEBPACK FOOTER //
// src/dialpad/components/layout/Offline.js